import { useState } from 'react';
import { api, apiError } from '../../../shared/api.js';
import { Icon } from '../../../layout/Icon.jsx';
import { toast } from '../../../shared/useToast.js';

export function SimulateScanModal({ gates, open, onClose }) {
  const [gateId, setGateId] = useState('');
  const [uid, setUid] = useState('');
  const [submitting, setSubmitting] = useState(false);

  if (!open) return null;

  async function submit(e) {
    e.preventDefault();
    if (!gateId || !uid.trim()) return;
    setSubmitting(true);
    try {
      await api.post(`/gates/${gateId}/simulate`, { cardUid: uid.trim() });
      toast.success('تمت محاكاة القراءة');
      setUid('');
      onClose?.();
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div
      className="fixed inset-0 z-50 grid place-items-center"
      style={{ background: 'rgba(0,0,0,.45)' }}
    >
      <form
        className="card p-5 w-[420px] space-y-3"
        onClick={(e) => e.stopPropagation()}
        onSubmit={submit}
      >
        <div className="flex items-center justify-between">
          <h3 className="text-[15px] font-bold">محاكاة قراءة كارت</h3>
          <button type="button" className="btn btn-ghost" onClick={onClose}>
            <Icon name="x" size={14} />
          </button>
        </div>

        <div>
          <label className="block text-xs font-semibold text-ink-2 mb-1">البوابة</label>
          <select
            className="input"
            value={gateId}
            onChange={(e) => setGateId(e.target.value)}
            required
          >
            <option value="">— اختر —</option>
            {gates.map((g) => (
              <option key={g._id || g.id} value={g._id || g.id}>{g.name}</option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-xs font-semibold text-ink-2 mb-1">UID الكارت</label>
          <input
            className="input"
            dir="ltr"
            style={{ textAlign: 'right', fontFamily: 'monospace' }}
            value={uid}
            onChange={(e) => setUid(e.target.value)}
            placeholder="مثال: RF1234"
            required
          />
        </div>

        <div className="flex justify-end gap-2 pt-2">
          <button type="button" className="btn" onClick={onClose}>إلغاء</button>
          <button type="submit" className="btn btn-primary" disabled={submitting}>
            {submitting ? 'جاري...' : 'تنفيذ'}
          </button>
        </div>
      </form>
    </div>
  );
}
